import {
  AboutUs,
  Benefits,
  JobOfferEmbedDetailsShowingV2ResponseDto,
  JobOfferEmbededOrganization,
  JobOfferPreview,
  Process,
  ProcessCard,
  Requirements,
  Responsibilities,
  TitleDescriptionIconItem,
} from "@/lib/interfaces/embed";

const mockedTitle1 = "Pflegefachkraft (m/w/d) in Sehnde";
const mockedTitle2 = "Pflegefachkraft";
const useTitle1 = true;

const mockedBenefits: Benefits = {
  title: "Deine Benefits bei uns",
  description: "Wir wissen, was dir wichtig ist. Deshalb bieten wir dir mehr als nur einen Job.",
  benefitItems: [
    {
      title: "Überdurchschnittliche Bezahlung",
      iconKey: "euro",
      description: "35€/Std. plus Zuschläge für Wochenenden und Feiertage. Deine Arbeit verdient faire Bezahlung.",
    },
    {
      title: "Flexible Arbeitszeiten",
      iconKey: "calendar",
      description: "Gestalte deinen Dienstplan mit. Wir berücksichtigen deine Wünsche und Bedürfnisse.",
    },
    {
      title: "Keine Nachtschichten",
      iconKey: "moon",
      description: "Arbeitszeiten zwischen 7-20 Uhr. Deine Work-Life-Balance ist uns wichtig.",
    },
    {
      title: "Firmenwagen",
      iconKey: "car",
      description: "Moderner Firmenwagen auch zur privaten Nutzung. Tankkarte inklusive.",
    },
    {
      title: "Fort- & Weiterbildung",
      iconKey: "education",
      description: "Regelmäßige Schulungen und Weiterbildungen. Wir investieren in deine Zukunft.",
    },
    {
      title: "Hansefit Mitgliedschaft",
      iconKey: "barbell",
      description: "Kostenlose Mitgliedschaft in über 5.000 Fitness- und Wellnesseinrichtungen.",
    },
    {
      title: "Digitale Ausstattung",
      iconKey: "tablet",
      description: "iPad für digitale Dokumentation und moderne Software für effizientes Arbeiten.",
    },
    {
      title: "VWL & Altersvorsorge",
      iconKey: "piggyBank",
      description: "Vermögenswirksame Leistungen und betriebliche Altersvorsorge für deine Zukunft.",
    },
    {
      title: "Familiäres Team",
      iconKey: "users",
      description: "Ein Team, das zusammenhält. Regelmäßige Teamevents und offene Kommunikation.",
    },
  ],
};

const mockedAboutUs: AboutUs = {
  description:
    "Seit über 15 Jahren sind wir dein verlässlicher Partner in der ambulanten Pflege. Mit Standorten in Sehnde, Hannover und Lehrte betreuen wir täglich über 200 Patienten mit Herz und Kompetenz.\n\nUnser Team besteht aus über 80 engagierten Mitarbeitern, die alle ein gemeinsames Ziel haben: Menschen in ihrer gewohnten Umgebung die bestmögliche Pflege zu bieten. Dabei setzen wir auf moderne Technik, faire Arbeitsbedingungen und ein familiäres Miteinander.",
  imageUrl: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
};

const mockedResponsibilitiesItems: TitleDescriptionIconItem[] = [
  {
    title: "Grundpflege",
    iconKey: "health",
    description: "Körperpflege, Mobilisation und Unterstützung im Alltag unserer Patienten",
  },
  {
    title: "Dokumentation",
    iconKey: "document",
    description: "Digitale Pflegedokumentation via iPad - einfach und zeitsparend",
  },
  {
    title: "Koordination",
    iconKey: "doctor",
    description: "Zusammenarbeit mit Ärzten, Therapeuten und Angehörigen",
  },
  {
    title: "Behandlungspflege",
    iconKey: "syringe",
    description: "Medikamentengabe, Wundversorgung und medizinische Betreuung nach ärztlicher Anordnung",
  },
  {
    title: "Beratung",
    iconKey: "communication",
    description: "Beratung von Patienten und Angehörigen in allen pflegerelevanten Fragen",
  },
  {
    title: "Beziehungspflege",
    iconKey: "heart",
    description: "Zeit für Gespräche und menschliche Nähe - das Wichtigste in der",
  },
];

const mockedResponsibilities: Responsibilities = {
  description: "Abwechslungsreich, sinnstiftend und immer mit dem Menschen im Mittelpunkt.",
  yourResponsibilities: mockedResponsibilitiesItems,
};

const mockedRequirements: Requirements = {
  description: "Wir suchen Menschen mit Herz und Kompetenz. Passt das zu dir?",
  necessary: [
    "Abgeschlossene Ausbildung als Pflegefachkraft, Gesundheits- und Krankenpfleger oder Altenpfleger",
    "Führerschein Klasse B (Firmenwagen wird gestellt)",
    "Freude am Umgang mit Menschen und Einfühlungsvermögen",
    "Zuverlässigkeit und Verantwortungsbewusstsein",
    "Teamfähigkeit und Kommunikationsstärke",
  ],
  preferred: [
    "Erfahrung in der ambulanten Pflege",
    "Zusatzqualifikationen (z.B. Wundmanagement, Palliativpflege)",
    "Sicherer Umgang mit digitalen Medien (iPad, Software)",
    "Organisationstalent und Flexibilität",
    "Positive Ausstrahlung und Humor",
  ],
};

const mockedProcessCards: ProcessCard[] = [
  {
    _id: "1",
    orderNumber: 1,
    title: "Kontaktdaten eintragen",
    description: "Füll einfach das kurze Formular aus - dauert weniger als 60 Sekunden.",
  },
  {
    _id: "2",
    orderNumber: 2,
    title: "WhatsApp-Kontakt",
    description: "Wir melden uns bei dir per WhatsApp.",
  },
  {
    _id: "3",
    orderNumber: 3,
    title: "Persönliches Kennenlernen",
    description: "Lerne unser Team und den Arbeitsalltag unverbindlich kennen.",
  },
];

const mockedProcess: Process = {
  title: "Unser Bewerbungsprozess",
  processCards: mockedProcessCards,
};

const jobOffer1: JobOfferPreview = {
  _id: "1",
  title: useTitle1 ? mockedTitle1 : mockedTitle2,
  hourlySalary: "35",
  location: "Sehnde",
  previewImageUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/eee8c0cd14-8103a31f0037f9e783b9.png",
  workingTimeModels: ["fullTime", "partTime"],
};

const jobOffer2: JobOfferPreview = {
  _id: "2",
  title: "Pflegefachkraft Teilzeit (m/w/d)",
  hourlySalary: "35",
  location: "Sehnde",
  previewImageUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/eee8c0cd14-8103a31f0037f9e783b9.png",
  workingTimeModels: ["partTime"],
};

const jobOffer3: JobOfferPreview = {
  _id: "3",
  title: "Pflegefachkraft (m/w/d)",
  hourlySalary: "34",
  location: "Lehrte",
  previewImageUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/eee8c0cd14-8103a31f0037f9e783b9.png",
  workingTimeModels: ["fullTime"],
};

const jobOffer4: JobOfferPreview = {
  _id: "4",
  title: "Altenpfleger (m/w/d)",
  hourlySalary: "36",
  location: "Hannover",
  previewImageUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/eee8c0cd14-8103a31f0037f9e783b9.png",
  workingTimeModels: ["fullTime"],
};

const mockedOrganization: JobOfferEmbededOrganization = {
  _id: "1",
  name: "Kandidat.io",
  color: "#0099CE",
  logoUrl:
    "/kandidat-io-favicon.svg",
  imprintLink: "https://kandidat.io/impressum",
  privacyPolicyLink: "https://kandidat.io/datenschutz",
};

/** Full demo payload for debug mode and Karriereportal settings when no live job exists. */
export function getMockJobPostV2(): JobOfferEmbedDetailsShowingV2ResponseDto {
  return {
    embedSettings: {
      heroEyebrowText: "Pflege mit Herz",
    },
    jobOfferPreview: { ...jobOffer1 },
    organization: { ...mockedOrganization },
    benefits: mockedBenefits,
    aboutUs: mockedAboutUs,
    responsibilities: mockedResponsibilities,
    requirements: mockedRequirements,
    process: mockedProcess,
    similarJobs: [jobOffer2, jobOffer3, jobOffer4],
  };
}
